export default {
  AD: {
    basic: {
      monthly: '5€',
      yearly: '49€',
    },
    pro: {
      monthly: '10€',
      yearly: '99€',
    },
    premium: {
      monthly: '25€',
      yearly: '225€',
    },
  },
  ES: {
    basic: {
      monthly: '5€',
      yearly: '49€',
    },
    pro: {
      monthly: '10€',
      yearly: '99€',
    },
    premium: {
      monthly: '25€',
      yearly: '225€',
    },
  },
  IT: {
    basic: {
      monthly: '5€',
      yearly: '49€',
    },
    pro: {
      monthly: '10€',
      yearly: '99€',
    },
    premium: {
      monthly: '25€',
      yearly: '225€',
    },
  },
  PT: {
    basic: {
      monthly: '5€',
      yearly: '49€',
    },
    pro: {
      monthly: '10€',
      yearly: '99€',
    },
    premium: {
      monthly: '25€',
      yearly: '225€',
    },
  },
  FR: {
    basic: {
      monthly: '5€',
      yearly: '49€',
    },
    pro: {
      monthly: '10€',
      yearly: '99€',
    },
    premium: {
      monthly: '25€',
      yearly: '225€',
    },
  },
  DE: {
    basic: {
      monthly: '5€',
      yearly: '49€',
    },
    pro: {
      monthly: '10€',
      yearly: '99€',
    },
    premium: {
      monthly: '25€',
      yearly: '225€',
    },
  },
  US: {
    basic: {
      monthly: '$6',
      yearly: '$59',
    },
    pro: {
      monthly: '$12',
      yearly: '$109',
    },
    premium: {
      monthly: '$30',
      yearly: '$249',
    },
  },
};
